import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetPointOfSalesCtrl = function (fn, er, selectedCode, token, ids) {


	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		}

	};
	var data = {
		codPointOfSales: selectedCode
	};


	axios
		.post(ApiConfig.url.GET_POINT_OF_SALES, data, config)
		.then(function (result) {
			fn(result.data)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});


}

export { GetPointOfSalesCtrl };